/**
 * Product Countdown Timer
 * Handles countdown timers for product cards
 */

class ProductCountdownTimer {
  constructor(element) {
    this.element = element;
    this.endDate = new Date(element.dataset.countdownEnd);
    this.productId = element.dataset.productId;
    
    // Cache dos elementos DOM
    this.daysElement = element.querySelector('[data-countdown-days]');
    this.hoursElement = element.querySelector('[data-countdown-hours]');
    this.minutesElement = element.querySelector('[data-countdown-minutes]');
    this.secondsElement = element.querySelector('[data-countdown-seconds]');
    
    // Validar data
    if (isNaN(this.endDate.getTime())) {
      console.error('Invalid countdown date:', element.dataset.countdownEnd);
      return;
    }
    
    // Iniciar countdown
    this.updateCountdown();
    this.intervalId = setInterval(() => this.updateCountdown(), 1000);
    
    // Limpar intervalo quando o elemento é removido
    this.setupCleanup();
  }
  
  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate.getTime() - now;
    
    // Se o tempo expirou
    if (distance < 0) {
      this.handleExpired();
      return;
    }
    
    // Calcular tempo restante
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    // Atualizar display
    this.updateDisplay(days, hours, minutes, seconds);
    
    // Adicionar classe de urgência se faltam menos de 60 segundos
    if (distance < 60000 && !this.element.classList.contains('product-countdown-timer--urgent')) {
      this.element.classList.add('product-countdown-timer--urgent');
    }
  }
  
  updateDisplay(days, hours, minutes, seconds) {
    if (this.daysElement) {
      this.daysElement.textContent = this.formatNumber(days);
    }
    if (this.hoursElement) {
      this.hoursElement.textContent = this.formatNumber(hours);
    }
    if (this.minutesElement) {
      this.minutesElement.textContent = this.formatNumber(minutes);
    }
    if (this.secondsElement) {
      this.secondsElement.textContent = this.formatNumber(seconds);
    }
  }
  
  formatNumber(num) {
    return num.toString().padStart(2, '0');
  }
  
  handleExpired() {
    // Para o intervalo
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    
    // Adiciona classe de expirado
    this.element.classList.add('product-countdown-timer--expired');
    this.element.classList.remove('product-countdown-timer--urgent');
    
    // Define todos os valores como zero
    this.updateDisplay(0, 0, 0, 0);
    
    // Dispatch evento customizado para permitir ações adicionais
    this.element.dispatchEvent(new CustomEvent('countdown:expired', {
      detail: { productId: this.productId },
      bubbles: true
    }));
  }
  
  setupCleanup() {
    // Observer para detectar quando o elemento é removido do DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.removedNodes.forEach((node) => {
          if (node === this.element || node.contains?.(this.element)) {
            this.destroy();
          }
        });
      });
    });
    
    // Observar o parent
    if (this.element.parentElement) {
      observer.observe(this.element.parentElement, { childList: true });
    }
    
    this.observer = observer;
  }
  
  destroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

// Inicializar timers quando o DOM estiver pronto
function initCountdownTimers() {
  const timers = document.querySelectorAll('.product-countdown-timer:not([data-countdown-initialized])');
  
  timers.forEach(timer => {
    timer.dataset.countdownInitialized = 'true';
    new ProductCountdownTimer(timer);
  });
}

// Inicializar no carregamento
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountdownTimers);
} else {
  initCountdownTimers();
}

// Reinicializar quando novas seções são carregadas (Shopify Theme Editor)
document.addEventListener('shopify:section:load', () => {
  setTimeout(initCountdownTimers, 100);
});

// Observar mudanças no DOM para carrosséis dinâmicos
const observer = new MutationObserver((mutations) => {
  let needsInit = false;
  
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) { // Element node
        if (node.classList?.contains('product-countdown-timer') || 
            node.querySelector?.('.product-countdown-timer')) {
          needsInit = true;
        }
      }
    });
  });
  
  if (needsInit) {
    initCountdownTimers();
  }
});

// Observar o body para mudanças
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Expor para uso global se necessário
window.ProductCountdownTimer = ProductCountdownTimer;
window.initCountdownTimers = initCountdownTimers;


